<template>
  <div class="menu">
    <div class="absolute mt-4">
      <a :href="maas_top_url()" class="flex border border-link rounded text-link ml-2 mr-3 px-2 py-1 bg-white">
        <span class="flex justify-center items-center text-sm whitespace-nowrap">{{ $t('tour_back') }}</span>
      </a>
    </div>
    <h2 class="section-title mt-4 mb-2 text-center text-lg">
      {{ $t('tour_route_search') }}
    </h2>
    <div class="px-4">
      <div class="mx-2 my-2 font-bold">From</div>
      <div class="ml-4 mr-2 my-2">Category</div>
      <div class="ml-4 mr-2 reservations-select border-gray-300 border">
        <select v-model="fromCategory" class="px-2" v-on:change="changeCategory('from')">
          <option v-for="category in categories" v-bind:key="category">
            {{ category }}
          </option>
        </select>
      </div>
      <div class="ml-4 mr-2 mt-2 reservations-select border-gray-300 border">
        <select v-model="from" class="px-2">
          <option v-for="point in fromPoints" v-bind:key="point.name" v-bind:value="point.no">
            {{ point.name }}
          </option>
        </select>
      </div>
      <div class="mx-2 my-2 font-bold">To</div>
      <div class="ml-4 mr-2 my-2">Category</div>
      <div class="ml-4 mr-2 reservations-select border-gray-300 border">
        <select v-model="toCategory" class="px-2" v-on:change="changeCategory('to')">
          <option v-for="category in categories" v-bind:key="category">
            {{ category }}
          </option>
        </select>
      </div>
      <div class="ml-4 mr-2 mt-2 reservations-select border-gray-300 border">
        <select v-model="to" class="px-2">
          <option v-for="point in toPoints" v-bind:key="point.name" v-bind:value="point.no">
            {{ point.name }}
          </option>
        </select>
      </div>
      <div class="mx-2 my-2">{{ $t('tour_departure_time_condition') }}</div>
      <div class="mx-2 my-2">
        <input :value="date" type="datetime-local" class="w-full p-2 border-gray-300 border h-12 rounded-lg" @change="setDate($event.target.value)">
      </div>
      <div class="mx-2 mt-4 mb-2">
        <a class="button-primary block" @click="reservation()">
          <span>{{ $t('tour_find_route') }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Constants from "../constants";
moment.tz.setDefault('Asia/Tokyo');

export default {
  name: 'reservations',
  data () {
    return {
      fromCategory: null,
      toCategory: null,
      categories: [],
      fromPoints: [],
      toPoints: [],
      from: null,
      to: null,
      date: moment().format('YYYY-MM-DDTHH:mm'),
      data: `1	田沢湖駅（エリアA）	たざわこえき	Tazawako station（Area A）	駅	Station	39.70046	140.7370197	田沢湖駅	Area A
2	生保内公園（エリアA）	おぼないこうえん	Obonai Park（Area A）	観光	Sightseeing	39.70688947	140.7370197	田沢湖駅	Area A
3	東風の湯（エリアA）	だしのゆ	Dashi-no-yu（Area A）	観光	Sightseeing	39.70606535	140.7310345	田沢湖駅	Area A
4	田沢湖マリーン（エリアB）	たざわこまりーん	Tazawako Marine（Area B）	観光	Sightseeing	39.73133485	140.6983565	田沢湖畔	Area B
5	田沢湖遊覧船（エリアB）	たざわこゆうらんせん	Tazawa Lake Cruise（Area B）	観光	Sightseeing	39.73101489	140.6980483	田沢湖畔	Area B
6	田沢湖キャンプ場（エリアB）	たざわこきゃんぷじょう	Tazawako Outdoor Tours（Area B）	観光	Sightseeing	39.7277765	140.7013485	田沢湖畔	Area B
7	田沢湖レンタサイクル（エリアB）	たざわこれんたさいくる	Tazawako Rent-a-Bike（Area B）	観光	Sightseeing	39.73227164	140.6991708	田沢湖畔	Area B
8	御座石神社（エリアB）	ござのいしじんじゃ	Gozanoishi jinja Shrine（Area B）	観光	Sightseeing	39.7517431	140.6505527	田沢湖畔	Area B
9	飲水思源像（エリアB	いんすいしげんぞう	Insuishigen（Area B）	観光	Sightseeing	39.73179654	140.6986484	田沢湖畔	Area B
10	クニマス未来館（エリアB）	くにますみらいかん	Lake Tazawa Kunimasu Trout Museum（AreaB）	観光	Sightseeing	39.70055975	140.6628531	田沢湖畔	Area B
11	思い出の潟分校（エリアB）	おもいでのかたぶんこう	Kata Branch School（Omoide no Katabunko）（Area B)	観光	Sightseeing	39.70029703	140.6629393	田沢湖畔	Area B
12	県民の森（エリアB）	けんみんのもり	People's Forest of Akita Prefectures（Area B）	観光	Sightseeing	39.72087867	140.695806	田沢湖畔	Area B
13	オートキャンプ場「縄文の森たざわこ」（エリアB）	おーときゃんぷじょう「じょうもんのもりたざわこ」	Lake Tazawa auto campsite（Area B）	観光	Sightseeing	39.74562351	140.6845966	田沢湖畔	Area B
14	むらっこ物産館（エリアB）	むらっこぶっさんかん	Murakko Product Center（Area B）	観光	Sightseeing	39.71497164	140.6261807	田沢湖畔	Area B
15	かたまえ山森林公園（エリアB）	かたまえやましんりんこうえん	Mount Katamae Forest Park（Area B）	観光	Sightseeing	39.71677213	140.6293522	田沢湖畔	Area B
16	たつこ像（エリアC）	たつこぞう	Statue of Tatsuko（Area C）	観光	Sightseeing	39.71428449	140.6342506	潟尻	Area C
17	田沢湖展望台（エリアC）	たざわこてんぼうだい	Tazawako Viewing Platform（Area C）	観光	Sightseeing	39.71678	140.6294249	潟尻	Area C
18	浮木神社（エリアC）	うききじんじゃ	Ukiki Shrine（Area C）	観光	Sightseeing	39.69634451	140.6622844	潟尻	Area C
19	山のはちみつ屋（エリアD）	やまのはちみつや	Yama no hachimitsuya（Area D)	観光	Sightseeing	39.74017622	140.7147708	田沢高原	Area D
20	田沢湖金色大観音（エリアD）	たざわここんじきだいかんのん	Tazawako Konjikidaikannon（Area D）	観光	Sightseeing	39.73939277	140.7231725	田沢高原	Area D
21	アルパこまくさ（エリアD）	あるぱこまくさ	Alpa Komakusa（Area D）	観光	Sightseeing	39.77746652	140.764096	田沢高原	Area D
22	たざわ湖スキー場（エリアD）	たざわこすきーじょう	Tazawako Ski Resort（Area D）	観光	Sightseeing	39.76250686	140.7707131	田沢高原	Area D
23	水沢第2砂防堰堤ボルダリングウォール（エリアD）	みずさわだいにさぼうえんていぼるだりんぐうぉーる	Bouldering Wall（Mizusawa No.2 Checkdam）（Area D）	観光	Sightseeing	39.75989477	140.7633095	田沢高原	Area D
24	サボーカルチャーパーク（エリアD）	さぼーかるちゃーぱーく	Sabo Culture Park（Area D）	観光	Sightseeing	39.76059352	140.7425554	田沢高原	Area D
25	秋田県立田沢湖スポーツセンター（エリアD）	あきたけんりつたざわこすぽーつせんたー	Tazawako Sports Center（Area D）	観光	Sightseeing	39.7603174	140.759485	田沢高原	Area D
26	休暇村乳頭温泉郷キャンプ場（エリアE）	きゅうかむらにゅうとうおんせんきょうきゃんぷじょう	Kyukamura Nyuto Onsenkyo Camping Ground（Area E）	観光	Sightseeing	39.79630208	140.7803363	乳頭温泉	Area E
27	田沢湖ハートハーブ（エリアB）	たざわこはーとはーぶ	Tazawako Herb Garden Heart Herb（Area B）	食事	Restaurant	39.74346121	140.6867763	田沢湖畔	Area B
28	湖畔の杜レストラン ORAE（エリアB）	こはんのもりれすとらん ORAE	Beer Restaurant ORAE（Area B）	食事	Restaurant	39.73800453	140.6944429	田沢湖畔	Area B
29	田沢湖レストハウス（エリアB）	たざわこれすとはうす	Tazawako Resthouse（Area B）	食事	Restaurant	39.73109995	140.6993978	田沢湖畔	Area B
30	田沢湖共栄パレス（エリアB）	たざわこきょうえいぱれす	Tazawako Kyoei  Palace（Area B）	食事	Restaurant	39.73209424	140.6995392	田沢湖畔	Area B
31	coffee&gallrey zawazawa（エリアB）	コーヒー＆ギャラリーザワザワ	coffee&gallrey zawazawa（Area B）	食事	Restaurant	39.73284719	140.6987162	田沢湖畔	Area B
32	グランビア 生ハム工房（エリアD）	ぐらんびあ なまはむこうぼう	Jamon de Greanvia（Area D）	食事	Restaurant	39.76072406	140.7418895	田沢高原	Area D
33	田沢湖高原ジンギスカン食堂（エリアD）	たざわここうげんじんぎすかんしょくどう	Jingisukan Dining（Area D）	食事	Restaurant	39.78027391	140.7624359	田沢高原	Area D
34	アグリ・アサノ・ファーム（エリアB）	あぐり・あさの・ふぁーむ	Farmstay Asano（Area B）	農家民宿	Farmstay	39.69817557	140.7272953	田沢湖畔	Area B
35	荷葉の郷 喜四郎（エリアB）	かようのさと きしろう	Farmstay Kishiro（Area B）	農家民宿	Farmstay	39.77316602	140.6867524	田沢湖畔	Area B
36	農家民宿 かまど（エリアB）	のうかみんしゅく かまど	Farmstay Kamado（Area B）	農家民宿	Farmstay	39.71650788	140.7236734	田沢湖畔	Area B
37	民宿 甚吉（エリアB）	みんしゅく じんきち	Farmstay Jinkichi（Area B）	農家民宿	Farmstay	39.73901542	140.7098759	田沢湖畔	Area B
38	民宿 惣之助（エリアB）	みんしゅく そうのすけ	Guesthouse Sounosuke（Area B）	農家民宿	Farmstay	39.73366259	140.7107605	田沢湖畔	Area B
39	農家民宿 輝湖（エリアB）	のうかみんしゅく てるこ	Farmstay Teruko（Area B）	農家民宿	Farmstay	39.70017087	140.6776411	田沢湖畔	Area B
40	民宿 孫六荘（エリアB）	みんしゅく まごろくそう	Farmstay Magorokuso（Area B）	農家民宿	Farmstay	39.73238095	140.708144	田沢湖畔	Area B
41	田沢湖湯治宿鳳凰館（エリアA）	たざわことうじやどほうおうかん	Guesthouse Hououkan（Area A）	宿泊	Hotel	39.70307962	140.735303	田沢湖駅	Area A
42	サウンズグッド！（エリアB）	さうんずぐっど！	Café&Inn  That Sounds Good!（Area B）	宿泊	Hotel	39.7462594	140.683144	田沢湖畔	Area B
43	かたくりの花（エリアB）	かたくりのはな	Hotel Katakuri-No-Hana（Area B）	宿泊	Hotel	39.73475164	140.6974855	田沢湖畔	Area B
44	花心亭しらはま（エリアB）	かしんていしらはま	Kashintei Shirahama（Area B）	宿泊	Hotel	39.73424874	140.6981645	田沢湖畔	Area B
45	ぺんしょん孫兵衛（エリアB）	ぺんしょんまごべえ	Lodge Magobe（Area B）	宿泊	Hotel	39.73564833	140.7073401	田沢湖畔	Area B
46	田沢湖ローズパークホテル（エリアC）	たざわころーずぱーくほてる	Tazawako Rose Park Hotel（Area C）	宿泊	Hotel	39.71308989	140.6347477	潟尻	Area C
47	天然温泉 田沢湖レイクリゾート（エリアD）	てんねんおんせん たざわこれいくりぞーと	Tazawako Lake Resort & Onsen（Area D）	宿泊	Hotel	39.74180572	140.727207	田沢高原	Area D
48	水沢温泉郷 青荷山荘（エリアD）	みずさわおんせんきょう あおにさんそう	Ryokan Aonisansou（Area D）	宿泊	Hotel	39.76502213	140.7529414	田沢高原	Area D
49	亀の井ホテル 田沢湖（エリアD）	かめのいほてる たざわこ	Kamenoi Hotel Tazawako（Area D）	宿泊	Hotel	39.7822216	140.765599	田沢高原	Area D
50	ホテルグランド天空（エリアD）	ほてるぐらんどてんくう	Hotel Grand Tencoo（Area D）	宿泊	Hotel	39.78239201	140.7618606	田沢高原	Area D
51	田沢高原ホテル（エリアD）	たざわここうげんほてる	Tazawa Plateau Hotel（Area D）	宿泊	Hotel	39.77927312	140.761919	田沢高原	Area D
52	田沢プラトーホテル（エリアD）	たざわぷらとーほてる	Tazawa Plateau Village（Area D）	宿泊	Hotel	39.78149702	140.762199	田沢高原	Area D
53	ロッジアイリス（エリアD）	ろっじあいりす	Lodge Iris（Area D）	宿泊	Hotel	39.78346941	140.7621945	田沢高原	Area D
54	宿 小町や（エリアD）	やど こまちや	Yado Komachiya（Area D）	宿泊	Hotel	39.77584152	140.7613299	田沢高原	Area D
55	露天風呂 水沢温泉（エリアD）	ろてんぶろ みずさわおんせん	Mizusawa Onsen（Area D）	宿泊	Hotel	39.76467865	140.7531984	田沢高原	Area D
56	元湯 水沢山荘（エリアD）	もとゆ みずさわさんそう	Mizusawasanso（Area D）	宿泊	Hotel	39.76530065	140.754229	田沢高原	Area D
57	ヒュッテ 旅人木（エリアD）	ひゅって りょじんぼく	Hutte Ryojinboku（Area D）	宿泊	Hotel	39.76483095	140.7588476	田沢高原	Area D
58	ロッジ 山の詩（エリアD）	ろっじ やまのうた	Lodge Yamanouta（Area D）	宿泊	Hotel	39.7653636	140.7581004	田沢高原	Area D
59	セルリアンリゾートAONI（エリアD）	せるりあんりぞーとあおに	Resort Hotel New Sky（Area D）	宿泊	Hotel	39.76546875	140.7531816	田沢高原	Area D
60	ヒュッテ ビルケ（エリアD）	ひゅって びるけ	Hutte Birke（Area D）	宿泊	Hotel	39.76538685	140.7583285	田沢高原	Area D
61	どんぐり山荘（エリアD）	どんぐりさんそう	Lodge Donguri Sanso（Area D）	宿泊	Hotel	39.76618636	140.7564847	田沢高原	Area D
62	山荘 風の又三郎（エリアD）	さんそう かぜのまたさぶろう	Lodge Kaze no Matasaburo（Area D）	宿泊	Hotel	39.76558495	140.7503174	田沢高原	Area D
63	ロッヂヨーデル（エリアD）	ろっぢよーでる	Lodge Yodel（Area D）	宿泊	Hotel	39.7660202	140.7557264	田沢高原	Area D
64	駒ヶ岳温泉（エリアD）	こまがたけおんせん	Komagatake Onsen（Area D）	宿泊	Hotel	39.75921262	140.7524473	田沢高原	Area D
65	ペンション 白い星（エリアD）	ぺんしょん しろいほし	Lodge Shiroi Hoshi（Area D）	宿泊	Hotel	39.7654374	140.7567985	田沢高原	Area D
66	丸駒荘（エリアD）	まるこまそう	Guesthouse Marukomaso（Area D）	宿泊	Hotel	39.76473405	140.7590205	田沢高原	Area D
67	ペンション クライマー（エリアD）	ぺんしょん くらいまー	Lodge Climber（Area D）	宿泊	Hotel	39.76550236	140.7498775	田沢高原	Area D
68	ログハウスの宿 仙人（エリアD）	ろぐはうすのやど せんにん	Log Guesthouse Sennin（Area D）	宿泊	Hotel	39.76040772	140.7409838	田沢高原	Area D
69	貸別荘山荘 イーグル（エリアD）	かしべっそうさんそう いーぐる	Rental Lodge Eagle（Area D）	宿泊	Hotel	39.76599819	140.7571847	田沢高原	Area D
70	湯の花本館（エリアD）	ゆのはなほんかん	Yunohana Honkan（Area D）	宿泊	Hotel	39.74460436	140.7200247	田沢高原	Area D
71	貸別荘フォレスト倶楽部田園（エリアD）	かしべっそうふぉれすとくらぶでんえん	Rental Lodge Forest Club Denen（Area D）	宿泊	Hotel	39.76506621	140.7496489	田沢高原	Area D
72	ホテルラディッシュハウス（エリアD）	ほてるらでぃっしゅはうす	Hotel Radish House（Area D）	宿泊	Hotel	39.76532966	140.7502069	田沢高原	Area D
73	民宿 かもしか（エリアD）	みんしゅく かもしか	Guesthouse Kamoshika（Area D）	宿泊	Hotel	39.76575415	140.7538018	田沢高原	Area D
74	乳頭温泉郷 鶴の湯温泉（エリアE）	にゅうとうおんせんきょう つるのゆおんせん	Tsurunoyu Onsen（Area E）	宿泊	Hotel	39.80532889	140.7797713	乳頭温泉	Area E
75	乳頭温泉郷 鶴の湯温泉別館 山の宿（エリアE）	にゅうとうおんせんきょう つるのゆおんせんべっかん やまのやど	Yama no Yado（Area E）	宿泊	Hotel	39.79592082	140.7687212	乳頭温泉	Area E
76	乳頭温泉郷 蟹場温泉（エリアE）	にゅうとうおんせんきょう がにばおんせん	Ganiba Onsen（Area E）	宿泊	Hotel	39.80626037	140.798559	乳頭温泉	Area E
77	乳頭温泉郷 黒湯温泉（エリアE）	にゅうとうおんせんきょう くろゆおんせん	Kuroyu Onsen（Area E）	宿泊	Hotel	39.80284961	140.8059267	乳頭温泉	Area E
78	乳頭温泉郷 妙乃湯（エリアE）	にゅうとうおんせんきょう たえのゆ	Tae no yu（Area E）	宿泊	Hotel	39.8036366	140.7975158	乳頭温泉	Area E
79	乳頭温泉郷 休暇村（エリアE）	にゅうとうおんせんきょう きゅうかむら	Kyukamura Nyuto Onsenkyo（Area E）	宿泊	Hotel	39.80108955	140.7947437	乳頭温泉	Area E
80	乳頭温泉郷 大釜温泉（エリアE）	にゅうとうおんせんきょう おおかまおんせん	Ookama Onsen（Area E）	宿泊	Hotel	39.80465367	140.7966875	乳頭温泉	Area E
81	乳頭温泉郷 孫六温泉（エリアE）	にゅうとうおんせんきょう まごろくおんせん	Magoroku Onsen（Area E）	宿泊	Hotel	39.80448489	140.8046791	乳頭温泉	Area E`
    }
  },
  mounted () {
    const lines = this.data.split('\n')
    for (let i = 0; i < lines.length; i++) {
      const cols = lines[i].split('\t')
      if (!this.categories.includes(cols[5])) {
        this.categories.push(cols[5])
      }
    }
    this.fromCategory = this.categories[0]
    this.toCategory = this.categories[0]
    this.changeCategory('from')
    this.changeCategory('to')
  },
  methods: {
    changeCategory: function (type) {
      const lines = this.data.split('\n')
      switch (type){
        case 'from':
          this.fromPoints.splice(0)
          for (let i = 0; i < lines.length; i++) {
            const cols = lines[i].split('\t')
            if (cols[5] === this.fromCategory){
              this.fromPoints.push({
                no: cols[0],
                name: cols[3]
              })
            }
          }
          this.from = this.fromPoints[0].no
          return
        case 'to':
          this.toPoints.splice(0)
          for (let i = 0; i < lines.length; i++) {
            const cols = lines[i].split('\t')
            if (cols[5] === this.toCategory){
              this.toPoints.push({
                no: cols[0],
                name: cols[3]
              })
            }
          }
          this.to = this.toPoints[0].no
          return
      }
    },
    setDate: function (value) {
      this.date = value
    },
    reservation: function () {
      if (this.from === this.to) {
        this.$alert({ message: 'The departure and arrival locations are the same.' })
        return
      }
      let params = []
      const d = moment(this.date)
      params.push('date=' + d.format('YYYYMMDD'))
      params.push('time=' + d.format('HHmm'))
      const lines = this.data.split('\n')
      for (let i = 0; i < lines.length; i++) {
        const cols = lines[i].split('\t')
        if(cols[0] === this.from) {
          params.push('frompoi=' + encodeURIComponent(cols[3]))
          params.push('fromlatitude=' + cols[6])
          params.push('fromlongitude=' + cols[7])
        } else if(cols[0] === this.to) {
          params.push('topoi=' + encodeURIComponent(cols[3]))
          params.push('tolatitude=' + cols[6])
          params.push('tolongitude=' + cols[7])
        }
      }
      const areaId = this.$store.getters['user/getAreaId']
      const url = Constants.REAL_TIME_SEARCH_WEB + "en/?serviceid=" + areaId + "&utm_source=" + this.convertAreaId(areaId) + "&utm_medium=referral&utm_campaign=" + this.convertAreaId(areaId) + '&' + params.join('&')
      window.open(url)
    },
    convertAreaId:function (areaId) {
      switch (areaId) {
        case "hitachinokunikiko":
          return 'mito'
        case "izunavi":
          return 'izu'
        case 'vin-de-yamanashi':
          return 'katsunuma'
        case 'nasu-ways':
          return 'nasu'
        case 'eeeechoshi':
          return 'choshi'
        case 'takkomaas':
          return 'takkomaas'
        default:
          return 'JR'
      }
    },
    maas_top_url: function () {
      const areaId = this.$store.getters['user/getAreaId']
      if (areaId == Constants.DEFAULT_AREA_ID) {
        return Constants.LINK_BASE_URL + '/'
      } else {
        return Constants.LINK_BASE_URL + '/' + areaId
      }
    },
  }
}
</script>
